import { compactAnalyticsParams } from "@/react/api/analytics/analyticsFilters";

import { absolutePathWithArrayIndices } from "../absolutePath";
import type { AnalyticsApiParams } from "./types";

type AnalyticsResource = "events" | "live";

export const buildAnalyticsPath = (
  resource: AnalyticsResource,
  action: string,
  params: AnalyticsApiParams,
) =>
  absolutePathWithArrayIndices(
    `analytics/${resource}/${action}`,
    compactAnalyticsParams(params),
  );
